import { Link } from "react-router-dom"

import "../../styles/Footer.css"

function Footer() {
  return (
    <div className="footer-container">

      <div className="footer-content-container-left">

        <div className="footer-content-left">        
          <span className="f-title">Roma Ristorante</span>
          <span>Federal Hill,</span>
          <span>310 Atwells Ave.</span>
          <span>Providence, RI</span>
          <span>Manager: Oliver Aldana</span>
          <span>(401)331-5000</span>
          <span>Romaonthehill@gmail.com</span>
          <span>Website Developed by Power Programming</span>
        </div>

        <div className="footer-navbar">
          <Link to="/home">Home</Link>
          <Link to="/about">About Us</Link>
          <Link to="/contact">Contact</Link>        

          <Link to="/dining">Dining</Link>
          <Link to="/catering">Catering / Banquet</Link>
        </div>

      </div>

      <div className="footer-content-right">
        <iframe 
          title="Roma-map" 
          width="100%" 
          height="100%" 
          loading="lazy" 
          src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJsYrI6QpF5IkRyGjNqnJGkAo&key=AIzaSyDoStL059QVI7A4_yft88HJlEPI8fgRHkg">
        </iframe>
      </div>

    </div>
  )
}

export default Footer
